export const APPLICANT_REFERRAL_CASE_SOURCES = ["APAC_CONSUMER"] as const;

export const REFERRAL_SHARE_MESSAGE_KEY =
  "Get $5 off your Certn background check with my referral link: {{url}}";
export const REFERRAL_SHARE_EMAIL_SUBJECT_KEY =
  "Get $5 off your Certn background check";

export const COPY_SUCCESS_MS = 2000;

export function isApprovedReferralCaseSource(
  source: string | null | undefined
): boolean {
  return (
    typeof source === "string" &&
    (APPLICANT_REFERRAL_CASE_SOURCES as readonly string[]).includes(source)
  );
}

export function buildReferralShareMessage(shareUrl: string) {
  return `Get $5 off your Certn background check with my referral link: ${shareUrl}`;
}

export function buildWhatsAppShareHref(message: string) {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}

export function buildSmsShareHref(message: string) {
  return `sms:?&body=${encodeURIComponent(message)}`;
}

export function buildMailtoShareHref(subject: string, message: string) {
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
    message
  )}`;
}

export async function copyTextToClipboard(value: string) {
  await navigator.clipboard.writeText(value);
}

export function canUseNativeShare() {
  return typeof navigator.share === "function";
}
